import { useEffect, useRef, useState } from 'react';
import Heading from '@components/Heading/Heading';
import styles from '@features/cms/components/categories/CategoryHeaderBlock/CategoryHeaderBlock.styles';
import { ICategoryHeaderBlock } from '@features/cms/typescript';
import theme from '@styles/theme';
import sanitizeHtml from '@utils/sanitizeHtml';
import RenderMedia from '@utils/RenderMedia';
type PropsType = {
  data: ICategoryHeaderBlock;
  defaultBackground?: string;
  isFirst?: boolean;
};
const CategoryHeaderBlock = ({
  data,
  defaultBackground = theme.rawColors.neutralWhite,
  isFirst = false
}: PropsType) => {
  const [mediaHeight, setMediaHeight] = useState(0);
  const {
    code,
    background,
    title,
    titleColor,
    description,
    descriptionColor,
    images,
    videos,
    imagesWithBlur,
    marginTop,
    marginBottom
  } = data;
  const contentRef = useRef<HTMLParagraphElement | null>(null);
  const onChangeHeight = () => {
    if (!contentRef.current) return;
    setMediaHeight(contentRef.current.clientHeight);
  };
  useEffect(() => {
    onChangeHeight();
    window.addEventListener('resize', onChangeHeight);
    return () => {
      window.removeEventListener('resize', onChangeHeight);
    };
  }, [contentRef.current]);
  return <header id={code} sx={styles.categoryHeaderContainer(background || defaultBackground, marginTop, marginBottom)} data-testid="category-header-block">
      <div sx={styles.headerContent}>
        <Heading h={isFirst ? 1 : 2} display={4} color={titleColor || theme.rawColors.neutralWhite} pb={24} mobile dangerouslySetInnerHTML={sanitizeHtml(title)} />
        <p sx={styles.descriptionText(descriptionColor || theme.rawColors.neutralWhite)} className="subtitle-special" ref={contentRef} dangerouslySetInnerHTML={sanitizeHtml(description)} />
      </div>
      <div sx={styles.imageContainer(mediaHeight)} data-testid="category-header-block-image-container">
        {RenderMedia(images, videos, true, imagesWithBlur, title, isFirst)}
      </div>
    </header>;
};
export default CategoryHeaderBlock;